<template lang="pug">
	.relative
		.flex.flex-wrap.items-center
			.text-xs.rounded-full.bg-indigo-1.px-2.py-1.flex.items-center.mr-2.cursor-pointer(class="hover:bg-indigo-2" v-if="isSelected(team)" v-for="team in companyTeams")
				.text-indigo-9 {{team}}
				eva-icon.icon.text-indigo-4.ml-1(width="16" height="16" name="close" @click="removeTeam(team)" v-if="!denyEdit")
			
			.relative(v-if="!denyEdit")
				eva-icon.icon.text-gray-4.cursor-pointer.mt-2(name="plus-circle" @click="showAddDropdown = true")
				
				.dropdown.absolute.left-0.top-0(v-if="showAddDropdown")
					.fixed.top-0.right-0.w-screen.h-screen.blur-bg-sm.z-10(@click="showAddDropdown = false")
					.relative.bg-white.p-4.shadow-xl.mt-10.rounded-lg.z-10
						input.w-48.h-8(placeholder="Team name..." v-focus v-model="newTeam" @keyup.enter="addNewTeam")
						p.text-gray-6.font-normal.text-xs Press enter to add a new team
						
						.h-px.bg-gray-3.my-2
						.flex.flex-wrap
							.text-xs.rounded-full.bg-gray-2.text-gray-7.px-2.py-1.flex.items-center.m-1.cursor-pointer(class="hover:bg-gray-3" v-if="!isSelected(team)" v-for="team in companyTeams" @click="addTeam(team)")
								p {{team}}
		
		.blur-bg-sm.whiter.absolute.top-0.right-0.bottom-0.left-0.flex.items-center.-m-1(v-if="loading")
			eva-icon.icon.spin.text-gray-6(name="loader-outline")
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Teams",
  props: ["selectedTeams", "edit", "parentType", "parentId", "denyEdit"],
  data() {
    return {
      companyTeams: [
        "Marketing",
        "Operations",
        "Product",
        "Design",
        "Engineering"
      ],
      newTeam: "",
      showAddDropdown: false,
      loading: false
    };
  },
  computed: {
    ...mapGetters(["company", "profile"])
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      if (this.company.teams.length) this.companyTeams = this.company.teams;
    },
    isSelected(team) {
      return this.selectedTeams.some(selectedTeam => selectedTeam == team);
    },
    addTeam(team) {
      this.loading = true;

      this.$store
        .dispatch("arrayUnion", {
          collection: this.parentType + "s",
          id: this.parentId,
          array: "teams",
          item: team
        })
        .then(() => {
          this.$store.dispatch("fireNotification", {
            title: "Assigned " + team + " team",
            type: "success"
          });
          if (this.parentType == "keyResult")
            return this.$store.dispatch(
              "getKeyResults",
              this.profile.companyId
            );
          if (this.parentType == "user")
            return this.$store.dispatch("getTeammates", this.profile.companyId);
        })
        .then(() => {
          this.loading = false;
          this.$emit("done");
        });
    },
    addNewTeam() {
      if (!this.newTeam) return;

      this.loading = true;
      this.$store
        .dispatch("arrayUnion", {
          collection: "companies",
          id: this.profile.companyId,
          array: "teams",
          item: this.newTeam
        })
        .then(() => {
          this.$store.dispatch("fireNotification", {
            title: "Added " + this.newTeam + " team to your company",
            type: "success"
          });
          this.$store
            .dispatch("getCompany", this.profile.companyId)
            .then(() => {
              this.setup();
              this.addTeam(this.newTeam);
              this.newTeam = "";
            });
        });
    },
    removeTeam(team) {
      this.loading = true;

      this.$store
        .dispatch("arrayDelete", {
          collection: this.parentType + "s",
          id: this.parentId,
          array: "teams",
          item: team
        })
        .then(() => {
          this.$store.dispatch("fireNotification", {
            title: "Removed " + team + " team",
            type: "success"
          });
          if (this.parentType == "keyResult")
            return this.$store.dispatch(
              "getKeyResults",
              this.profile.companyId
            );
          if (this.parentType == "user")
            return this.$store.dispatch("getTeammates", this.profile.companyId);
        })
        .then(() => {
          this.loading = false;
          this.$emit("done");
        });
    }
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus();
      }
    }
  }
};
</script>

<style lang="sass" scoped></style>
